import React from 'react';
import { List } from '@mui/material';

export default props => <List {...props} />;
